export enum NetGross {
  Gross = 1,
  Net = 2,
  Both = 3,
}
